import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default function (params) {
  const { data, exec, isLoading, isRequestSuccessed } = useRequest({
    url: '',
    name: 'GET_PRODUCT_PAGE',
  });

  const fetchData = function () {
    if (params) {
      let url = `/api/products`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  return [data || {}, fetchData, isLoading, isRequestSuccessed];
}
